import { Flex, StyledInput, Form } from "@shared/primitive-components"
import { useCallback, useState } from "react"
import * as styles from "./styles/vrnInputStyles"

interface vrnProps {
  onChange: (value: string) => void
  dataTestId?: string
  value: string
  error?: string
}

export const errors = {
  INVALID_VRN_ERROR_MESSAGE: `Invalid registration number`,
  VEHICLE_IN_POLICY: `This vehicle is already on cover`,
}

const checkVRNInputError = (error: string): string =>
  error.includes(`vehicle is already on your policy`) ? errors.VEHICLE_IN_POLICY : errors.INVALID_VRN_ERROR_MESSAGE

export const VRNInput = ({ onChange, value = ``, error, dataTestId }: vrnProps) => {
  const [inputValue, setValue] = useState(value)

  const onValueChange = useCallback(
    (newValue) => {
      setValue(newValue)
      onChange(newValue)
    },
    [setValue, onChange]
  )

  return (
    <>
      <Flex css={styles.styledInputContainer}>
        <StyledInput
          name="registrationNumber"
          placeholder="AB11 ABC"
          data-testid={dataTestId}
          value={inputValue}
          onPaste={(event) => {
            event.preventDefault()
            const newValue = event.clipboardData.getData(`Text`).trim()
            onValueChange(newValue)
          }}
          onChange={(event) => {
            const newValue = event.target.value.toUpperCase()
            onValueChange(newValue)
          }}
        />
      </Flex>
      {error && <Form.InputError>{checkVRNInputError(error)}</Form.InputError>}
    </>
  )
}

VRNInput.defaultProps = {
  error: false,
  dataTestId: undefined,
}
